import React from 'react';
import { useSelector } from 'react-redux';
import localStorageService from '../../services/localStorageService';
import OrganizationAdminDashboard from './OrganizationAdminDashboard';
import CaseOfficerDashboard from './CaseOfficerDashboard';
import CaseManagerDashboard from './CaseManagerDashboard';
import OrganizationHeadDashboard from './OrganizationHeadDashboard';
import SuperAdminDashboard from './SuperAdminDashboard';
import FirstRespondantDashboard from './FirstRespondantDashboard';
import DirectorCIDDashboard from './DirectorCIDDashboard';
import DirectorNCPADashboard from './DirectorNCPADashboard';
import DeputyDirectorDashboard from './DeputyDirectorDashboard';
import OICDashboard from './OICDashboard';

const Dashboard = () => {
  // Try Redux first, fall back to localStorage
  const reduxUser = useSelector((state) => state?.auth?.user);
  const storedUser = localStorageService.getItem('user');
  const user = reduxUser || storedUser || null;

  const hasRole = (roleName) => {
    if (!user || !user.roles) return false;
    const roles = Array.isArray(user.roles) ? user.roles : [];
    return roles.some((r) => String(r).toLowerCase() === String(roleName).toLowerCase());
  };

  // Decide dashboard by role. Order matters (first match wins).
  const dashboardForRole = () => {
    //if (hasRole('Super Admin')) return <CaseOfficerDashboard />;
    if (hasRole('Super Admin')) return <SuperAdminDashboard />;
    if (hasRole('Organization Admin')) return <OrganizationAdminDashboard />;
    if (hasRole('Organization Head')) return <OrganizationHeadDashboard />;
    if (hasRole('Case Manager',)) return <CaseManagerDashboard />;
    if (hasRole('Director CID')) return <DirectorCIDDashboard />;
    if (hasRole('Director NCPA')) return <DirectorNCPADashboard />;
    if (hasRole('Deputy Director')) return <DeputyDirectorDashboard />;
    if (hasRole('OIC')) return <OICDashboard />;
    if (hasRole('Case Officer')) return <CaseOfficerDashboard />;
    if (hasRole('First Respondent')) return <FirstRespondantDashboard />;
    if (hasRole('Department Head',)) return <CaseManagerDashboard />;
    if (hasRole('Team Leader First Respondent',)) return <CaseManagerDashboard />;
    if (hasRole('Call Center Officer MoWCA',)) return <CaseManagerDashboard />;
    if (hasRole('Legal Officer',)) return <CaseOfficerDashboard  />;
     if (hasRole('Counselling Officer',)) return <CaseOfficerDashboard  />;
    // if (hasRole('Super Admin')) return <SuperAdminDashboard />;
    // fallback
    return <div></div>;
  };

  return <div className="w-full">{dashboardForRole()}</div>;
};

export default Dashboard;